import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center" data-id="element-0">
    <p className="text-xl md:text-3xl font-display italic text-brand-greenDark/85 leading-relaxed" data-id="element-1">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-celeste/25 selection:text-brand-greenDark bg-brand-surface" data-id="element-2">
      <UrgencyBanner data-id="element-3" />
      <Hero data-id="element-4" />
      <InitialTestimonials data-id="element-5" />
      <PainPoints data-id="element-6" />
      <MethodOverview data-id="element-7" />
      <MaterialPreview data-id="element-8" />
      <MoreTestimonials data-id="element-9" />
      <Pricing data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <CostComparison data-id="element-13" />
      <TransitionPhrase data-id="element-14" />
      <EmotionalClose data-id="element-15" />
      <Footer data-id="element-16" />
      <FloatingNotification data-id="element-17" />
    </div>;
}